import { styled, Checkbox as CheckboxLib } from "@mui/material";

export const Checkbox = styled(CheckboxLib)({
  padding: 0,
  svg: {
    fontSize: 20,
  },
});
